import { resolveNarrativeEngineMode } from './narrativeEngineMode';
import App from './App';
import OriginalEngineApp from './originalEngine/OriginalEngineApp';

export function resolveAppComponent() {
  const mode = resolveNarrativeEngineMode(import.meta.env.VITE_NARRATIVE_ENGINE_MODE, {
    allowDefault: import.meta.env.DEV,
  });
  if (mode === 'ORIGINAL_ENGINE_COMPAT') return OriginalEngineApp;
  return App;
}
